import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { ArrowRightIcon } from '@deliveryhero/armor-icons';
import { useDatePickerTopBarClassNames } from './hooks/useDatePickerTopBarClassNames';
import { useDatePickerTopBar } from './hooks/useDatePickerTopBar';
import { DatePickerTopBarRoot, DatePickerTopBarMonthNavigation, DatePickerTopBarMonthNavigationButtonBackward, DatePickerTopBarMonthNavigationButtonForward, DatePickerTopBarMonthYearSelectorToggle } from './style';
import { DATE_PICKER_TOP_BAR_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
export var DatePickerTopBar = forwardRef(function DatePickerTopBar(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DATE_PICKER_TOP_BAR_CLASS_PREFIX);
  var classNameComponents = useDatePickerTopBarClassNames(DATE_PICKER_TOP_BAR_CLASS_PREFIX, className);

  var _useDatePickerTopBar = useDatePickerTopBar(props, ref),
      rootProps = _useDatePickerTopBar.rootProps,
      monthYearSelectorToggleProps = _useDatePickerTopBar.monthYearSelectorToggleProps,
      monthNavigationButtonBackwardProps = _useDatePickerTopBar.monthNavigationButtonBackwardProps,
      monthNavigationButtonForwardProps = _useDatePickerTopBar.monthNavigationButtonForwardProps,
      year = _useDatePickerTopBar.year,
      monthName = _useDatePickerTopBar.monthName;

  return React.createElement(DatePickerTopBarRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerTopBarMonthYearSelectorToggle, Object.assign({}, monthYearSelectorToggleProps, {
    theme: theme,
    className: classNameComponents.MonthYearSelectorToggle
  }), monthName, " ", year), React.createElement(DatePickerTopBarMonthNavigation, {
    theme: theme,
    className: classNameComponents.MonthNavigation
  }, React.createElement(DatePickerTopBarMonthNavigationButtonBackward, Object.assign({}, monthNavigationButtonBackwardProps, {
    theme: theme,
    className: classNameComponents.MonthNavigationButtonBackward
  }), React.createElement(ArrowRightIcon, {
    medium: true,
    className: classNameComponents.ArrowRightIcon
  })), React.createElement(DatePickerTopBarMonthNavigationButtonForward, Object.assign({}, monthNavigationButtonForwardProps, {
    theme: theme,
    className: classNameComponents.MonthNavigationButtonForward
  }), React.createElement(ArrowRightIcon, {
    medium: true,
    className: classNameComponents.ArrowRightIcon
  }))));
});
DatePickerTopBar.defaultProps = {};